export const agentRoutes = {
  agent: {
    route: '/agent',
    isTopLevel: true,
  },
  agentTaskDetails: {
    route: '/:jobId',
  },
};

export const getAgentBaseRoute = () => {
  return agentRoutes.agent.route;
};

export const getShipsyAgentRoute = () => {
  return getAgentBaseRoute();
};

export const getShipsyAgentTaskDetailsRoute = () => {
  return `${getAgentBaseRoute()}${agentRoutes.agentTaskDetails.route}`;
};

export const getFullRouteForId = (routeId) => {
  const routeObj = agentRoutes[routeId];
  if (!routeObj) {
    return null;
  }
  if (routeId === 'agent') {
    return getAgentBaseRoute();
  }
  return `${getAgentBaseRoute()}${routeObj.route}`;
};

